import { SvgIcon, SvgIconProps } from '@mui/material';

const ImportIcon = (props: SvgIconProps) => (
  <SvgIcon { ...props } viewBox="0 0 17 14">
    <path
      // eslint-disable-next-line max-len
      d="M8.25 0.75V8.75M8.25 8.75L5.25 5.75M8.25 8.75L11.25 5.75M15.75 8.08333V11.0833C15.75 11.6138 15.5393 12.1225 15.1642 12.4975C14.7891 12.8726 14.2804 13.0833 13.75 13.0833H2.75C2.21957 13.0833 1.71086 12.8726 1.33579 12.4975C0.960714 12.1225 0.75 11.6138 0.75 11.0833V8.08333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export default ImportIcon;
